import { limit, orderBy, query, where } from 'firebase/firestore';
import { useMemo } from 'react';
import { useCollection } from '@/lib/firestore/hooks';
import { notificationsCol } from '@/lib/firestore/refs';
import type { Notification } from '@shared/types';

/** The signed-in user's notifications, newest first (needs the recipientUid + createdAt composite index). */
export function useMyNotifications(uid: string | null) {
  const q = useMemo(() => (uid ? query(notificationsCol(), where('recipientUid', '==', uid), orderBy('createdAt', 'desc'), limit(50)) : null), [uid]);
  return useCollection<Notification>(q, [uid]);
}
